export default __webpack_public_path__ + "static/media/Tiger's Armbands of the Untamed.39d12fa2.jpg";